export default "__VITE_ASSET__BOMgbSXi__"